import { Directive } from '@angular/core';
import { Validators, Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[tzValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: TzValidatorDirective, multi: true }]
})
export class TzValidatorDirective implements Validator {

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any; } {
    let valid =this.checkIdNumber(control.value);
    return valid == true ? null : { 'tzValue':  'TZ not valid'  };
  }

  checkIdNumber(value) {
    var strValue = this.pad(value, 9, null);
    var leng = strValue.length;
    var sum = 0;
    var mul = 1;
    if (leng === 0) {
      return true;
    }
    var strID = strValue;
    var objRegExp = new RegExp("[^0-9]", "g");
    if (objRegExp.test(strValue)) {
      return false;
    } else if ((leng > 9)) {
      return false;
    } else if ((leng < 9) && (leng >= 4)) //checking for leading zero
    {
      var addNull = 9 - leng;
      var addn = "0";
      for (i = 1; i <= addNull - 1; i++)
        addn = addn + "0";
      strID = addn + value;
      leng = strID.length;
    } else {
      if (leng < 4) {
        return false;
      }
    }
    //----- Algorithm CheckID Number ---------------------------------------
    for (var i = 0; i < leng; i++) {
     let sum2 = (mul * (1 * (strID.substr(i, 1))));
      if (sum2 > 9)
        sum2 = sum2 - 9;
      sum = sum + sum2;
      mul = 3 - mul;
    }
    sum = sum % 10;
    var result = 10 - sum;
    if (result == 10)
      result = 0;
    if ((1 * (strID.substr(i, 1))) != result) {
      return false;
    }
    //idnum.value = strID;
    return true;
  }

  //build in function from portal - check id
  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

}
